<template>
  <v-container fluid>
    <v-card min-height="60vh">
      <v-toolbar color="indigo" dense class="rounded rounded-b-0">
        <v-toolbar-title class="white--text">
          Impostazioni
          <v-icon color="white"> mdi-cog </v-icon>
        </v-toolbar-title>

        <!-- Pulsante torna indietro -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="goBack()"
              class="ml-auto mr-5"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon color="error"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span v-if="menu == true">Vai alla Dashboard</span>
          <span v-else>Torna indietro</span>
        </v-tooltip>
      </v-toolbar>

      <!-- Row MENU -->
      <v-row class="mt-15 mx-5 d-flex justify-center" v-if="menu == true">
        <v-col cols="4" v-for="(card, i) in prefisso == 'ferraraquarzi' ? cards_fq : cards" :key="i">
          <v-card
            @click="cambiaComponente(card.component)"
            height="150px"
            hover
            class="d-flex align-center justify-center"
            style="border-radius: 12px;"
          >
            <div>
              <v-icon size="60" color="primary">{{ card.icona }}</v-icon>
              <div style="font-size: 20px" class="primary--text">
                {{ card.titolo }}
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <QLTurni ref="turni" />
      <QLPartenza v-if="partenza" ref="partenza" />
      <QLZoneCompetenza v-if="zone_competenza" ref="zone_competenza" />
      <QLMateriali v-if="materiali" ref="materiali" />
      <QLClassiPericolosita v-if="classi_pericolosita" ref="pericolosita" />
      <QLCalendario v-if="calendario" ref="calendario" />
      <QLTipiSegnalazione v-if="tipi_segnalazione" ref="tipi_segnalazione" />
      <QLDashboardDefault v-if="dashboard_default" ref="dashboard_default" />
    </v-card>
  </v-container>
</template>
<script>
import QLMateriali from "./QLCOMPONENTS/QLConfig/QLMateriali.vue";
import QLTurni from "./QLCOMPONENTS/QLConfig/QLTurni.vue";
import QLPartenza from "./QLCOMPONENTS/QLConfig/QLPartenza.vue";
import QLClassiPericolosita from "./QLCOMPONENTS/QLConfig/QLClassiPericolosita.vue";
import QLCalendario from "./QLCOMPONENTS/QLConfig/QLCalendario.vue";
import QLTipiSegnalazione from "./QLCOMPONENTS/QLConfig/QLTipiSegnalazione.vue";
import QLDashboardDefault from "./QLCOMPONENTS/QLConfig/QLDashboardDefault.vue";
import QLZoneCompetenza from "./QLCOMPONENTS/QLConfig/QLZoneCompetenza.vue";

export default {
  name: "QLConfig",

  components: {
    QLPartenza,
    QLTurni,
    QLMateriali,
    QLClassiPericolosita,
    QLCalendario,
    QLTipiSegnalazione,
    QLDashboardDefault,
    QLZoneCompetenza
  },

  props: {},

  data() {
    return {
      // Variabili d'appoggio
      prefisso: localStorage.prefisso_user,
      calendario: false,
      classi_pericolosita: false,
      zone_competenza: false,
      menu: true,
      materiali: false,
      partenza: false,
      tipi_segnalazione: false,
      dashboard_default: false,
      // Array
      cards: [
        {
          titolo: "Turni e Fasce",
          icona: "mdi-clipboard-text-clock",
          component: "turni",
        },
        {
          titolo: "Partenza",
          icona: "mdi-google-maps",
          component: "partenza",
        },
        {
          titolo: "Materiali",
          icona: "mdi-circle-opacity",
          component: "materiali",
        },
        {
          titolo: "Classi Pericolosità",
          icona: "mdi-alert-circle",
          component: "classi_pericolosita",
        },
        {
          titolo: "Calendario",
          icona: "mdi-calendar",
          component: "calendario",
        },
        {
          titolo: "Tipi Segnalazione",
          icona: "mdi-alert",
          component: "tipi_segnalazione",
        },
        {
          titolo: "Dashboard Default",
          icona: "mdi-chart-bar",
          component: "dashboard_default",
        },
      ],
      cards_fq: [
        {
          titolo: "Luoghi",
          icona: "mdi-google-maps",
          component: "partenza",
        },
        {
          titolo: "Aree Competenza",
          icona: "mdi-map-legend",
          component: "zone_competenza",
        },
        {
          titolo: "Materiali",
          icona: "mdi-circle-opacity",
          component: "materiali",
        },
        {
          titolo: "Classi Pericolosità",
          icona: "mdi-alert-circle",
          component: "classi_pericolosita",
        },
        {
          titolo: "Calendario",
          icona: "mdi-calendar",
          component: "calendario",
        },
        {
          titolo: "Tipi Segnalazione",
          icona: "mdi-alert",
          component: "tipi_segnalazione",
        },
        {
          titolo: "Dashboard Default",
          icona: "mdi-chart-bar",
          component: "dashboard_default",
        },
      ],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    cambiaComponente(component) {
      if (component == "partenza") {
        this.partenza = true;
      } else if (component == "materiali") {
        this.materiali = true;
      } else if (component == "classi_pericolosita") {
        this.classi_pericolosita = true;
      } else if (component == "calendario") {
        this.calendario = true;
      } else if (component == "tipi_segnalazione") {
        this.tipi_segnalazione = true;
      }else if (component == "dashboard_default") {
        this.dashboard_default = true;
      }else if (component == "zone_competenza") {
        this.zone_competenza = true;
      }
      this.menu = false;
    },
    goBack() {
      if (
        this.partenza ||
        this.materiali ||
        this.classi_pericolosita ||
        this.calendario ||
        this.tipi_segnalazione ||
        this.dashboard_default
      ) {
        this.partenza = false;
        this.materiali = false;
        this.classi_pericolosita = false;
        this.calendario = false;
        this.tipi_segnalazione = false;
        this.dashboard_default = false;
        return (this.menu = true);
      }
      // torna alla home di quicklogistic
      else this.$router.push("/home/quicklogistic");
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>